<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.LaboratoryCenterImg')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.Team") }} </div>
            </template>

            <template #ContentEr>
              <li>
                <router-link to="/LaboratoryCenter">
                  <div style="color: #1d2088">{{ $t("menu.LaboratoryCenter") }} </div>
                </router-link>

              </li>
            </template>


            <template #ContentSan>
              <li><router-link to="/Recruitment">
                  <div>{{ $t("menu.Recruitment") }} </div>
                </router-link></li>
            </template>

          </Content>

        </el-col>
        <el-col :span="17">
          <router-view></router-view>
        </el-col>
      </el-row>
    </div>
    <!-- 底部 -->
    <MyFooter> </MyFooter>
  </div>
</template>


<style scoped>
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}

.conta {
  margin-top: 161px;
}

.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}

.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}

.fff {
  background: #ffffff;
  padding: 0px 20px;
  margin-bottom: 20px;
}

a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}

a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1D2088;
}
</style>

<script>
export default {
  name: "LaboratoryCenter",

  data() {
    return {
      number: "4-1",


    };
  },
  methods: {


  },

};
</script>